"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSameSiteStrictSupported = void 0;
var _getCookie = _interopRequireDefault(require("./getCookie"));
var cookieDomain = process.env.REACT_APP_GOOGLE_OAUTH_COOKIE_DOMAIN || process.env.NEXT_PUBLIC_GOOGLE_OAUTH_COOKIE_DOMAIN;
var isSameSiteStrictSupported = exports.isSameSiteStrictSupported = function isSameSiteStrictSupported() {
  var tomorrow = new Date().getTime() + 86400000;
  document.cookie = "samesitesupport=true;path=/;expires=".concat(new Date(tomorrow).toGMTString(), ";domain=").concat(cookieDomain, ";secure;samesite=strict;");
  return (0, _getCookie["default"])('samesitesupport').cookieExists;
};